import { render } from "./PCCodeScannerTiposLecturas.vue?vue&type=template&id=7fbf8b68&scoped=true"
import script from "./PCCodeScannerTiposLecturas.vue?vue&type=script&lang=js"
export * from "./PCCodeScannerTiposLecturas.vue?vue&type=script&lang=js"

import "./PCCodeScannerTiposLecturas.vue?vue&type=style&index=0&id=7fbf8b68&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7fbf8b68"]])

export default __exports__